import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import openai from '../../../services/openaiClient';

const ContractDeadlineActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('upcoming');
  const [aiQuery, setAiQuery] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const [isLoadingAI, setIsLoadingAI] = useState(false);
  const [reminderDays, setReminderDays] = useState('3');
  const [autoEscalate, setAutoEscalate] = useState(false);

  const handleAIDeadlineAnalysis = async () => {
    setIsLoadingAI(true);
    try {
      const completion = await openai?.chat?.completions?.create({
        model: 'gpt-3.5-turbo',
        messages: [
          {
            role: 'system',
            content: 'أنت مساعد ذكي متخصص في إدارة مواعيد العقود والمواعيد النهائية. ساعد في تحديد الأولويات وتقديم توصيات.'
          },
          {
            role: 'user',
            content: aiQuery || 'كيف يمكنني إدارة مواعيد العقود القريبة بشكل أفضل؟'
          }
        ],
        temperature: 0.7,
        max_tokens: 500
      });
      
      setAiResponse(completion?.choices?.[0]?.message?.content || 'لم يتم الحصول على رد');
    } catch (error) {
      console.error('AI Analysis Error:', error);
      setAiResponse('حدث خطأ في تحليل الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.');
    } finally {
      setIsLoadingAI(false);
    }
  };

  const handleSaveReminderSettings = () => {
    console.log('Saving reminder settings:', { reminderDays, autoEscalate });
    alert('تم حفظ إعدادات التذكير بنجاح');
  };

  const tabs = [
    { id: 'upcoming', label: 'المواعيد القادمة', icon: 'Calendar' },
    { id: 'ai-priority', label: 'تحديد الأولويات', icon: 'Brain' },
    { id: 'reminders', label: 'إعدادات التذكير', icon: 'Bell' }
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="مواعيد العقود"
      icon="FileText"
      iconColor="#F59E0B"
      size="xl"
      footer={null}
    >
      {/* Tabs */}
      <div className="flex gap-2 mb-6 border-b border-border">
        {tabs?.map(tab => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-2 border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' :'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span>{tab?.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === 'upcoming' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">المواعيد النهائية القادمة</h3>
            
            <div className="space-y-3">
              <div className="p-4 border-l-4 border-red-500 bg-red-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-red-900">CNT-2026-001</h4>
                    <p className="text-sm text-red-700">شقة فاخرة في دبي مارينا</p>
                  </div>
                  <span className="px-2 py-1 bg-red-200 text-red-800 text-xs rounded font-semibold">24 ساعة</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-red-700">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    ٢٠٢٦/٠١/١١
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    أحمد محمد
                  </span>
                </div>
              </div>

              <div className="p-4 border-l-4 border-orange-500 bg-orange-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-orange-900">CNT-2026-005</h4>
                    <p className="text-sm text-orange-700">فيلا في الريم</p>
                  </div>
                  <span className="px-2 py-1 bg-orange-200 text-orange-800 text-xs rounded font-semibold">3 أيام</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-orange-700">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    ٢٠٢٦/٠١/١٣
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    سارة أحمد
                  </span>
                </div>
              </div>

              <div className="p-4 border-l-4 border-yellow-500 bg-yellow-50 rounded-lg">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-yellow-900">CNT-2026-008</h4>
                    <p className="text-sm text-yellow-700">مكتب تجاري في الشميساني</p>
                  </div>
                  <span className="px-2 py-1 bg-yellow-200 text-yellow-800 text-xs rounded font-semibold">5 أيام</span>
                </div>
                <div className="flex items-center gap-4 text-sm text-yellow-700">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    ٢٠٢٦/٠١/١٥
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={14} />
                    محمد خالد
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-6">
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-red-600">5</p>
                <p className="text-xs text-red-700">عاجل (24 ساعة)</p>
              </div>
              <div className="p-3 bg-orange-50 border border-orange-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-orange-600">12</p>
                <p className="text-xs text-orange-700">قريب (3 أيام)</p>
              </div>
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-center">
                <p className="text-2xl font-bold text-yellow-600">23</p>
                <p className="text-xs text-yellow-700">قادم (أسبوع)</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'ai-priority' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">تحديد الأولويات بالذكاء الاصطناعي</h3>
            
            <div className="space-y-3">
              <label className="block text-sm font-medium">اسأل عن إدارة المواعيد</label>
              <Input
                value={aiQuery}
                onChange={(e) => setAiQuery(e?.target?.value)}
                placeholder="مثال: ما هي العقود التي يجب أن أعطيها الأولوية هذا الأسبوع؟"
                className="w-full"
              />
              <Button
                onClick={handleAIDeadlineAnalysis}
                disabled={isLoadingAI}
                className="w-full"
              >
                {isLoadingAI ? (
                  <span className="flex items-center gap-2">
                    <Icon name="Loader" size={18} className="animate-spin" />
                    جاري التحليل...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    <Icon name="Brain" size={18} />
                    تحليل الأولويات
                  </span>
                )}
              </Button>
            </div>

            {aiResponse && (
              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start gap-2 mb-2">
                  <Icon name="Lightbulb" size={20} className="text-blue-600 mt-1" />
                  <h4 className="font-semibold text-blue-900">توصيات الذكاء الاصطناعي</h4>
                </div>
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{aiResponse}</p>
              </div>
            )}

            <div className="mt-6 p-4 bg-muted/30 rounded-lg">
              <h4 className="font-semibold mb-3 flex items-center gap-2">
                <Icon name="Target" size={18} className="text-primary" />
                معايير تحديد الأولوية
              </h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>الوقت المتبقي حتى الموعد النهائي</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>قيمة العقد المالية</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>أهمية العميل (VIP)</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-green-600 mt-0.5" />
                  <span>تعقيد العقد ومتطلباته</span>
                </li>
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'reminders' && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-foreground mb-4">إعدادات التذكير</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">التذكير قبل الموعد النهائي</label>
                <select
                  value={reminderDays}
                  onChange={(e) => setReminderDays(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background"
                >
                  <option value="1">يوم واحد</option>
                  <option value="3">3 أيام</option>
                  <option value="5">5 أيام</option>
                  <option value="7">أسبوع</option>
                  <option value="14">أسبوعين</option>
                </select>
              </div>

              <div className="flex items-center gap-3 p-4 border border-border rounded-lg">
                <input
                  type="checkbox"
                  id="auto-escalate"
                  checked={autoEscalate}
                  onChange={(e) => setAutoEscalate(e?.target?.checked)}
                  className="w-4 h-4"
                />
                <label htmlFor="auto-escalate" className="flex-1">
                  <span className="font-medium">التصعيد التلقائي</span>
                  <p className="text-sm text-muted-foreground">تصعيد العقود المتأخرة تلقائياً إلى المشرف</p>
                </label>
              </div>

              <div className="p-4 bg-muted/30 rounded-lg">
                <h4 className="font-semibold mb-3">قنوات التذكير</h4>
                <div className="space-y-2">
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <Icon name="Bell" size={16} />
                    <span className="text-sm">إشعارات النظام</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" defaultChecked className="w-4 h-4" />
                    <Icon name="Mail" size={16} />
                    <span className="text-sm">البريد الإلكتروني</span>
                  </label>
                  <label className="flex items-center gap-2">
                    <input type="checkbox" className="w-4 h-4" />
                    <Icon name="MessageSquare" size={16} />
                    <span className="text-sm">رسالة نصية SMS</span>
                  </label>
                </div>
              </div>

              <Button
                onClick={handleSaveReminderSettings}
                className="w-full"
                variant="primary"
              >
                <span className="flex items-center gap-2">
                  <Icon name="Save" size={18} />
                  حفظ الإعدادات
                </span>
              </Button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ContractDeadlineActionsModal;